import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Icon from '/component/base/Icon';
import {darkGray} from '/theme/color/on.color';

import {styles} from '../BottomTabNavigation.style';

export const renderBarIcon =
  ({routeName, tabs}: any) =>
  (options = {}) => {
    const size = get(options, 'size', '');
    const focused = get(options, 'focused', false);
    const color = get(options, 'color', darkGray);

    const {activeIcon, icon} =
      tabs.find(({name}: any) => name === routeName) || {};

    const iconStyle = {
      ...styles.tabBarTabIcon,
      color: color,
      fontSize: size,
    } as const;

    return (
      <View style={styles.tabBarTabIconContainer} accessible={false}>
        {focused ? (
          <View style={[styles.tabBarTabActiveBar, {backgroundColor: color}]} />
        ) : null}
        <Icon name={focused ? activeIcon : icon} style={iconStyle} />
      </View>
    );
  };
